import update from "immutability-helper";
import { REQUEST_PAST_BOOKINGS, SET_PAST_BOOKINGS } from './past-bookings-actions';

const initialState = {
  isFetching: false,
  journeyReports: []
};

function pastBookingsReducer(state = initialState, action) {
  switch (action.type) {
    case REQUEST_PAST_BOOKINGS:
      return update(state, {
        isFetching: {$set: true}
      });
    case SET_PAST_BOOKINGS:
      return update(state, {
        journeyReports: {$set: action.payload}
      });
    default:
      return state;
  }
}

export default pastBookingsReducer;



// WEBPACK FOOTER //
// ./src/components/past-bookings/past-bookings-reducer.js